import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import { OAuth } from '../OAuth/OAuth.js';
import { AuthInput } from '../AuthInput/AuthInput.js';
import { useExternalWallets } from '../../providers/ExternalWalletContext.js';
import { useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
export const AuthOptions = ({ oAuthMethods, disableEmailLogin, disablePhoneLogin }) => {
    const { wallets } = useExternalWallets();
    const showAllOAuth = useModalStore(state => state.step === ModalStep.AUTH_MORE);
    const Content = useMemo(() => {
        const Methods = [];
        if (!!(oAuthMethods === null || oAuthMethods === void 0 ? void 0 : oAuthMethods.length)) {
            Methods.push(_jsx(OAuth, { methods: oAuthMethods }, "oAuth"));
        }
        if (!disableEmailLogin || !disablePhoneLogin) {
            Methods.push(_jsx(AuthInput, { disableEmailLogin: disableEmailLogin, disablePhoneLogin: disablePhoneLogin }, "input"));
        }
        return _jsx(_Fragment, { children: Methods });
    }, [showAllOAuth, oAuthMethods, disableEmailLogin, disablePhoneLogin, wallets]);
    return _jsx(Container, { children: Content });
};
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
